import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Spinner } from 'telia-front-react';

import InvoiceDetailsStore from '../../../stores/InvoiceDetailsStore';
import ClosableModal from '../../common/ClosableModal';
import InfoNotice from '../notices/InfoNotice';

import InvoiceDetailsModal from './InvoiceDetailsModal';

interface IInvoiceDetailsModalWrapperProps {
  invoiceDetailsStore?: InvoiceDetailsStore;
}

@inject('invoiceDetailsStore')
@observer
export default class InvoiceDetailsModalWrapper extends React.Component<IInvoiceDetailsModalWrapperProps> {
  public render(): JSX.Element {
    const gaGroup = 'Invoice details';
    const gaPage = this.props.invoiceDetailsStore.gaPageLabel;

    if (this.props.invoiceDetailsStore.invoiceDetailsLoading) {
      return (
        <ClosableModal gaPage={gaPage} gaGroup={gaGroup}>
          <Spinner />
        </ClosableModal>
      );
    }
    if (this.props.invoiceDetailsStore.invoiceNotFound) {
      return (
        <ClosableModal gaPage={gaPage} gaGroup={gaGroup}>
          <InfoNotice translationKey="shared.invoice-details-modal.invoice-not-found" />
        </ClosableModal>
      );
    }
    return <InvoiceDetailsModal gaGroup={gaGroup} />;
  }
}
